import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Color, DoubleSide } from "three";
import { COLORS } from "../../../utils";
import ShadowPlane from "../r3f-components/components/ShadowPlane";
const Grid = ({ size = 10, divisions = 10, rotation = [0, 0, 0], position = [0, 0, 0], color: c = COLORS.aether, }) => {
    const color = new Color(c);
    return (_jsxs(_Fragment, { children: [_jsxs("mesh", { position: position, rotation: [Math.PI / 2, 0, 0], children: [_jsx("circleGeometry", { args: [0.3, 20] }), _jsx("meshBasicMaterial", { color: COLORS.nebula, opacity: 0.3, transparent: true, side: DoubleSide })] }), _jsx("gridHelper", { args: [size, divisions, color, color], rotation: rotation, position: position }), _jsx(ShadowPlane, { rotation: [-Math.PI / 2, 0, 0], occlusion: true })] }));
};
export default Grid;
